// Enum to identify the special gift cards
const specialGiftCard = {
  E99999: 'E99999',
  E62764: 'E62764',
  G62764: 'G62764',
  G62683: 'G62683',
};

export default specialGiftCard;
